export const ROLES = {
 installer: 1,
 inspector: 2,
 coordinator: 3,
 superadmin: 4
}